import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { Button, Select } from '../../components';

export default class InvitePatientModal extends React.Component {
	static propTypes = {
		isOpen: PropTypes.bool,
		onCancel: PropTypes.func.isRequired,
		isGeneratingCode: PropTypes.bool,
		onGenerateCode: PropTypes.func.isRequired,
		inviteCode: PropTypes.string,
		providersWithCodes: PropTypes.array
	}

	state = {
		firstName: '',
		lastName: '',
		birthDate: '',
		providerCode: 'none'
	}

	componentDidUpdate(prevProps) {
		if (prevProps.isOpen && !this.props.isOpen) {
			this.setState({
				firstName: '',
				lastName: '',
				birthDate: '',
				providerCode: 'none'
			});
		}
	}

	handleFirstNameChange = ({ target }) => {
		this.setState({ firstName: target.value });
	}

	handleLastNameChange = ({ target }) => {
		this.setState({ lastName: target.value });
	}

	handleBirthDateChange = ({ target }) => {
		this.setState({ birthDate: target.value });
	}

	handleProviderChosen = ({ target }) => {
		this.setState({ providerCode: target.value });
	}

	handleCreateInviteClick = () => {
		const inviteData = this.state;
		if (inviteData.providerCode === 'none') {
			delete inviteData.providerCode;
		}
		this.props.onGenerateCode(inviteData);
	}

	render () {
		const { isOpen, onCancel, isGeneratingCode, inviteCode, providersWithCodes = [] } = this.props;
		const { firstName, lastName, birthDate, providerCode } = this.state;
		let formattedCode;

		if (inviteCode) {
			formattedCode = `${inviteCode.substring(0, 3)}-${inviteCode.substring(3, 6)}-${inviteCode.substring(6)}`;
		}

		const providerOptions = providersWithCodes.map(provider => ({
			value: provider.provider_code, label: `${provider.name_first} ${provider.name_last}, ${provider.credentials}`
		}));
		providerOptions.unshift({ value: 'none', label: 'None' });

		return (
			<Modal isOpen={isOpen} contentLabel="Patient Invite" className="modal-dialog modal-sm">
				<div className="modal-content">
					<div className="modal-header">
						<div className="clearfix">
							<div className="pull-right">
								<button className="btn btn-link" onClick={onCancel}>
									<em className="fa fa-lg fa-times" />
								</button>
							</div>
							<h3 className="modal-title">
								Create Patient Invite
							</h3>
							<p>Fill in all fields to generate a one-time use code you can give to your patient to ease signing up</p>
						</div>
					</div>
					{inviteCode ? (
						<div className="modal-body">
							<p className="text-center">The following code has been generated for</p>
							<h4 className="text-center"><strong>{firstName} {lastName}</strong></h4>
							<h3 className="text-center">
								<pre>{formattedCode}</pre>
							</h3>
							<p className="text-center">The patient will now be able to use this invite code and their birth date to register for a new Care Convene account.</p>
						</div>
					) : (
						<div className="modal-body form">
							<div className="form-group">
								<label>First Name</label>
								<input type="text" className="form-control" value={firstName} onChange={this.handleFirstNameChange} />
							</div>
							<div className="form-group">
								<label>Last Name</label>
								<input type="text" className="form-control" value={lastName} onChange={this.handleLastNameChange} />
							</div>
							<div className="form-group">
								<label>Date of Birth</label>
								<input type="date" className="form-control" value={birthDate} onChange={this.handleBirthDateChange} />
							</div>
							<div className="form-group">
								<label>Link With Provider</label>
								<Select
									onChange={this.handleProviderChosen}
									selectedValue={providerCode}
									options={providerOptions}
								/>
							</div>
						</div>
					)}
					<div className="modal-footer">
						<div className="pull-right">
							{inviteCode ? (
								<Button
									title="Close"
									large
									onClick={onCancel}
								/>
							) : (
								<React.Fragment>
									<Button
										title="Cancel"
										large
										onClick={onCancel}
										disabled={isGeneratingCode}
									/>
									<Button
										title="Create Invite"
										onClick={this.handleCreateInviteClick}
										disabled={isGeneratingCode}
										large
										primary
										className="ml"
									/>
								</React.Fragment>
							)}
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}
